export default "__VITE_ASSET__ZmYVmXl8__"